import { ICourse } from '@interfaces/ICourse';

export interface ICoursesState {
  courses: ICourse[];
}

export const initialCoursesState: ICoursesState = {
  courses: [],
};
